// extracted by mini-css-extract-plugin
export default {"container":"StoreAndLanguageSelector__container___pDXj8","dropdown":"StoreAndLanguageSelector__dropdown___xNAeC"};